module.exports = __webpack_public_path__ + "static/media/obr_poz_3.7643e81f.jpg";